<template>
  <b-button-toolbar key-nav aria-label="Toolbar with button groups">
    <b-button-group class="mx-1" size="sm">
      <b-button class="mx-1" variant="primary" @click="handleAddItemClick">
        <b-icon icon="plus-circle" aria-label="Add New Item" />
      </b-button>
      <b-button variant="outline-dark">&laquo; </b-button>
      <b-button variant="outline-dark">&lsaquo; </b-button>
    </b-button-group>
    <b-button-group class="mx-1" size="sm">
      <b-button
        :variant="variantForDocStatus(null)"
        @click="handleStatusClick(null)"
        >All
      </b-button>
      <b-button
        :variant="variantForDocStatus('approved')"
        @click="handleStatusClick('approved')"
      >
        Approved
      </b-button>
      <b-button
        :variant="variantForDocStatus('submitted')"
        @click="handleStatusClick('submitted')"
        >Submitted
      </b-button>
      <b-button
        :variant="variantForDocStatus('hold')"
        @click="handleStatusClick('hold')"
      >
        ON Hold
      </b-button>
      <b-button
        :variant="variantForDocStatus('rejected')"
        @click="handleStatusClick('rejected')"
      >
        Rejected
      </b-button>
    </b-button-group>
    <b-button-group class="mx-1" size="sm">
      <b-button variant="outline-dark">&rsaquo; </b-button>
      <b-button variant="outline-dark">&raquo; </b-button>
    </b-button-group>
    <b-input-group>
      <template #prepend>
        <b-input-group-text>
          <b-icon icon="search"></b-icon>
        </b-input-group-text>
      </template>
      <b-form-input
        placeholder="Search items ..."
        class="text-left"
        v-model="searchStr"
        @input="handleSearchStr"
      />
    </b-input-group>
    <b-button class="mx-1" variant="primary">
      <b-icon icon="download" aria-label="Download" />
    </b-button>
  </b-button-toolbar>
</template>

<script>
export default {
  name: "Admin_Manage_Sessions_Toolbar",
  components: {},
  props: {
    status: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    variantForDocStatus(status) {
      return this.status === status
        ? this.statusBtnSelectedVariant
        : this.statusBtnVariant;
    },
    handleStatusClick(status) {
      this.$emit("status-click", status);
      //this.status = status;
    },
    totalDocCount(docLevel) {
      return this.items && Array.isArray(this.items)
        ? this.items.filter(aSession => {
            return (
              aSession.hasOwnProperty(docLevel) && aSession[docLevel] !== null
            );
          }).length
        : 0;
    },
    handleSearchStr() {
      this.$emit("search-input", this.searchStr);
    },
    handleAddItemClick() {
      this.$emit("add-item-click");
    }
  },
  data() {
    return {
      searchStr: null,
      docLevel: "doc_stage", //doc, doc_stage //versions, doc_local |all | submitted | needs_work | inactive
      statusBtnVariant: "outline-warning",
      statusBtnSelectedVariant: "warning",
      showSessionsStatus: "all",
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }]
    };
  }
};
</script>

<style lang="scss" scoped>
.add-users {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-user {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-user {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.items {
  margin-top: 20px;
  .ico {
    cursor: pointer;
  }
  .cover-img {
    width: 150px;
  }
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.post {
  cursor: pointer;
  padding: 5px 15px;
  border-bottom: 1px solid #000;
  span {
    font-weight: bold;
  }
}
.active {
  background: rgb(164, 214, 255);
}
.track-images {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.track-image {
  cursor: pointer;
  width: 130px;
  height: 100px;
  border-radius: 10px;
  margin: 10px 15px;
}
.active-image {
  border: 5px solid var(--theme-color);
}
.entry {
  padding: 7px;
  .heading {
    width: 120px;
    margin-right: 15px;
    font-weight: bold;
  }
}
.track {
  display: grid;
  grid-template-columns: 198px 1fr;
  grid-column-gap: 23px;
  margin-bottom: 24px;
  align-items: stretch;
  .img-track {
    width: 198px;
    height: 100%;
    & > div {
      height: 100%;
    }
    img {
      height: 152px;
      width: 100%;
      object-fit: cover;
    }
  }
}
.session-content {
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #52595e;
    margin-bottom: 8px;
  }
  .description {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #8d99a0;
    margin-bottom: 8px;
  }
  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .read-more-btn {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: right;
      color: var(--theme-color);
    }
    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 8px;
      .read {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
  }
  .track-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .author {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      grid-column-gap: 12px;
      img {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      grid-column-gap: 16px;
    }
  }
}
.tools {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
}
.detail-tools {
  width: 370px;
  border: 1px solid #eceff9;
}
.status {
  margin-top: 0.5rem;
  .status-btn {
    display: inline-block;
    margin-right: 15px;
    width: 105px;
    height: 21px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    background: var(--theme-color);
    text-align: center;
    border: none;
    border-radius: 3px;
  }
}

.actions {
  display: flex;
  justify-content: space-evenly;
}
.owner-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.items .colWidth {
  max-width: 100px;
}
</style>
